/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Saved_Without_FieldsInputs */

const en_case_create_incomplete_saved_without_fields = /** @type {(inputs: Case_Create_Incomplete_Saved_Without_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case saved. Some required data could not be validated. Review the case details to finish creation.`)
};

const pt_br2_case_create_incomplete_saved_without_fields = /** @type {(inputs: Case_Create_Incomplete_Saved_Without_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso salvo. Não foi possível validar alguns dados obrigatórios. Revise os dados do caso para concluir a criação.`)
};

/**
* | output |
* | --- |
* | "Case saved. Some required data could not be validated. Review the case details to finish creation." |
*
* @param {Case_Create_Incomplete_Saved_Without_FieldsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_saved_without_fields = /** @type {((inputs?: Case_Create_Incomplete_Saved_Without_FieldsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Saved_Without_FieldsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_saved_without_fields(inputs)
	return pt_br2_case_create_incomplete_saved_without_fields(inputs)
});